/*@jsxRuntime automatic @jsxImportSource react*/
/*<!-- vale Google.Headings = NO -->*/
/*<!-- vale Google.Headings = YES -->*/
/*<!-- vale Google.Headings = NO -->*/
/*<!-- vale Google.Headings = YES -->*/
import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
import {useMDXComponents as _provideComponents} from "@mdx-js/react";
import {Docs} from 'components/layout';
import {getIntegrations} from 'api/get-integrations';
import {getExtensions} from 'api/get-extensions';
import {Warning, Tip, Info, WhitelistDetails} from 'ui';
export const lastUpdatedDate = new Date(1780358400000);
export async function getStaticProps() {
  const integrations = await getIntegrations();
  const extensions = await getExtensions();
  return {
    props: {
      ...integrations,
      extensions,
      meta: {
        title: null,
        description: null,
        lastUpdatedDate: "Tue Jun 02 2026 00:00:00 GMT+0000 (Coordinated Universal Time)",
        slug: "slack",
        type: "destination",
        icon: null,
        toc: [{
          "value": "Overview",
          "depth": 0,
          "id": "overview"
        }, {
          "value": "Supported syncing",
          "depth": 0,
          "id": "supported-syncing"
        }, {
          "value": "Slack error alerting",
          "depth": 1,
          "id": "slack-error-alerting"
        }, {
          "value": "Connect to Slack",
          "depth": 0,
          "id": "connect-to-slack"
        }, {
          "value": "Authenticating with OAuth",
          "depth": 1,
          "id": "authenticating-with-oauth"
        }, {
          "value": "Adding the Hightouch bot to a channel",
          "depth": 1,
          "id": "adding-the-hightouch-bot-to-a-channel"
        }, {
          "value": "Sync configuration",
          "depth": 0,
          "id": "sync-configuration"
        }, {
          "value": "Syncing messages",
          "depth": 1,
          "id": "syncing-messages"
        }, {
          "value": "Syncing batch messages",
          "depth": 1,
          "id": "syncing-batch-messages"
        }, {
          "value": "Syncing tables",
          "depth": 1,
          "id": "syncing-tables"
        }, {
          "value": "Syncing CSV files",
          "depth": 1,
          "id": "syncing-csv-files"
        }, {
          "value": "Templating messages",
          "depth": 1,
          "id": "templating-messages"
        }, {
          "value": "Slack Block Kit",
          "depth": 1,
          "id": "slack-block-kit"
        }, {
          "value": "Customizing bot appearance",
          "depth": 1,
          "id": "customizing-bot-appearance"
        }, {
          "value": "Tips and troubleshooting",
          "depth": 0,
          "id": "tips-and-troubleshooting"
        }, {
          "value": "Common errors",
          "depth": 1,
          "id": "common-errors"
        }, {
          "value": "Live debugger",
          "depth": 1,
          "id": "live-debugger"
        }, {
          "value": "Sync alerts",
          "depth": 1,
          "id": "sync-alerts"
        }]
      }
    },
    revalidate: 60
  };
}
const MDXLayout = ({children, ...props}) => _jsx(Docs, Object.assign({}, props, {
  children: children
}));
function MDXContent(props = {}) {
  return MDXLayout ? _jsx(MDXLayout, Object.assign({}, props, {
    children: _jsx(_createMdxContent, {})
  })) : _createMdxContent();
  function _createMdxContent() {
    const _components = Object.assign({
      h2: "h2",
      p: "p",
      ul: "ul",
      li: "li",
      table: "table",
      thead: "thead",
      tr: "tr",
      th: "th",
      tbody: "tbody",
      td: "td",
      strong: "strong",
      h3: "h3",
      a: "a",
      code: "code",
      ol: "ol",
      img: "img",
      h4: "h4",
      em: "em",
      pre: "pre"
    }, _provideComponents(), props.components), {RowAndColumnOrderingInfo, PylonLink, CommonErrorsPreface, LiveDebugger, SyncAlerts} = _components;
    if (!CommonErrorsPreface) _missingMdxReference("CommonErrorsPreface", true);
    if (!LiveDebugger) _missingMdxReference("LiveDebugger", true);
    if (!PylonLink) _missingMdxReference("PylonLink", true);
    if (!RowAndColumnOrderingInfo) _missingMdxReference("RowAndColumnOrderingInfo", true);
    if (!SyncAlerts) _missingMdxReference("SyncAlerts", true);
    return _jsxs(_Fragment, {
      children: [_jsx(_components.h2, {
        id: "overview",
        children: "Overview"
      }), "\n", _jsx(_components.p, {
        children: "With the Slack destination, Hightouch can serve as a notifier for various data-related events or changes.\nThis is a very flexible integration that you can use for many different use cases, such as:"
      }), "\n", _jsxs(_components.ul, {
        children: ["\n", _jsx(_components.li, {
          children: "notifying your Customer Success teams when product usage for a key account suddenly drops"
        }), "\n", _jsx(_components.li, {
          children: "notifying an Account Executive when product usage surpasses a certain threshold"
        }), "\n", _jsx(_components.li, {
          children: "sending a daily summary of the number of sign-ups compared to the same day in the previous month"
        }), "\n", _jsx(_components.li, {
          children: "sending a daily summary on the adoption of a core feature"
        }), "\n"]
      }), "\n", _jsx(_components.h2, {
        id: "supported-syncing",
        children: "Supported syncing"
      }), "\n", _jsxs(_components.table, {
        children: [_jsx(_components.thead, {
          children: _jsxs(_components.tr, {
            children: [_jsx(_components.th, {
              align: "left",
              children: "Sync type"
            }), _jsx(_components.th, {
              align: "left",
              children: "Description"
            })]
          })
        }), _jsxs(_components.tbody, {
          children: [_jsxs(_components.tr, {
            children: [_jsx(_components.td, {
              align: "left",
              children: _jsx(_components.strong, {
                children: "Message"
              })
            }), _jsx(_components.td, {
              align: "left",
              children: "Sends individual messages for each row that was added, changed, or removed since the last sync. There will be no messages for the initial run."
            })]
          }), _jsxs(_components.tr, {
            children: [_jsx(_components.td, {
              align: "left",
              children: _jsx(_components.strong, {
                children: "Batch Message"
              })
            }), _jsx(_components.td, {
              align: "left",
              children: "Sends a formatted message (or multiple messages) of all the rows in the query results."
            })]
          }), _jsxs(_components.tr, {
            children: [_jsx(_components.td, {
              align: "left",
              children: _jsx(_components.strong, {
                children: "Table"
              })
            }), _jsx(_components.td, {
              align: "left",
              children: "Sends a formatted table of all rows in the query results as a single message."
            })]
          }), _jsxs(_components.tr, {
            children: [_jsx(_components.td, {
              align: "left",
              children: _jsx(_components.strong, {
                children: "CSV"
              })
            }), _jsx(_components.td, {
              align: "left",
              children: "Sends a CSV file of all rows in the query results attached to a single message."
            })]
          })]
        })]
      }), "\n", _jsx(RowAndColumnOrderingInfo, {
        variant: "message"
      }), "\n", _jsx(_components.h3, {
        id: "slack-error-alerting",
        children: "Slack error alerting"
      }), "\n", _jsxs(_components.p, {
        children: ["To learn more about setting up Slack as your error alerting tool, see the ", _jsx(_components.a, {
          href: "/syncs/alerting",
          children: "Alerting"
        }), " page."]
      }), "\n", _jsx(_components.h2, {
        id: "connect-to-slack",
        children: "Connect to Slack"
      }), "\n", _jsx(_components.h3, {
        id: "authenticating-with-oauth",
        children: "Authenticating with OAuth"
      }), "\n", _jsxs(_components.p, {
        children: ["Use OAuth to connect Slack by navigating to ", _jsx(_components.strong, {
          children: "Destinations"
        }), " > ", _jsx(_components.strong, {
          children: "Create New"
        }), " > ", _jsx(_components.strong, {
          children: "Slack"
        }), ".\nClick ", _jsx(_components.strong, {
          children: "Connect"
        }), " and log in with your desired Slack account.\nOnce you have selected your desired workspace, click ", _jsx(_components.strong, {
          children: "Allow"
        }), " and you will see an ", _jsx(_components.strong, {
          children: "Authorization successful"
        }), " screen in Hightouch.\nFinish your setup by clicking the continue button and naming your destination."]
      }), "\n", _jsx(_components.h3, {
        id: "adding-the-hightouch-bot-to-a-channel",
        children: "Adding the Hightouch bot to a channel"
      }), "\n", _jsx(_components.p, {
        children: "In order for Hightouch to message your channel, you need to ensure the Hightouch bot is added as an integration.\nFollow the steps below to add the bot to your channel."
      }), "\n", _jsx(Tip, {
        children: _jsx(_components.p, {
          children: "You can add the Hightouch bot both to public and private Slack channels."
        })
      }), "\n", _jsxs(_components.p, {
        children: ["Adding the Hightouch bot can be done by typing ", _jsx(_components.code, {
          children: "/invite @hightouch"
        }), " in the Slack composer. If that doesn't work you can also add the Hightouch bot by following these steps:"]
      }), "\n", _jsxs(_components.ol, {
        children: ["\n", _jsxs(_components.li, {
          children: ["\n", _jsxs(_components.p, {
            children: ["Go to your channel and click the dropdown button (", _jsx(_components.strong, {
              children: "∨"
            }), ") next to the channel name.\n", _jsx(_components.img, {
              src: "destinations/destination-slack-channel.png",
              alt: "Adding Hightouch bot to channel - step 1"
            })]
          }), "\n"]
        }), "\n", _jsxs(_components.li, {
          children: ["\n", _jsxs(_components.p, {
            children: ["Click ", _jsx(_components.strong, {
              children: "Integrations"
            }), " > ", _jsx(_components.strong, {
              children: "Add an App"
            }), ".\n", _jsx(_components.img, {
              src: "destinations/destination-slack-channel-integrations.png",
              alt: "Adding Hightouch bot to channel - step 2"
            })]
          }), "\n"]
        }), "\n", _jsxs(_components.li, {
          children: ["\n", _jsxs(_components.p, {
            children: ["Search for ", _jsx(_components.strong, {
              children: "Hightouch"
            }), " and click ", _jsx(_components.strong, {
              children: "Add"
            }), " next to the Hightouch app name.\n", _jsx(_components.img, {
              src: "destinations/destination-slack-channel-add-hightouch.png",
              alt: "Adding Hightouch bot to channel - step 3"
            })]
          }), "\n"]
        }), "\n", _jsxs(_components.li, {
          children: ["\n", _jsxs(_components.p, {
            children: ["The Hightouch bot should now appear in the channel settings.\n", _jsx(_components.img, {
              src: "destinations/destination-slack-channel-bot-added.png",
              alt: "Adding Hightouch bot to channel - step 4"
            })]
          }), "\n"]
        }), "\n"]
      }), "\n", _jsx(_components.h2, {
        id: "sync-configuration",
        children: "Sync configuration"
      }), "\n", _jsxs(_components.p, {
        children: ["Once you've set up your Slack destination and have a ", _jsx(_components.a, {
          href: "/getting-started/concepts#models",
          children: "model"
        }), " to pull data from, you can set up your sync configuration to begin syncing data.\nGo to the ", _jsxs(_components.a, {
          href: "https://app.hightouch.com/syncs?from=docs",
          children: [_jsx(_components.strong, {
            children: "Syncs"
          }), " overview page"]
        }), " and click the ", _jsx(_components.strong, {
          children: "Add sync"
        }), " button to begin.\nThen, select the relevant model and the Slack destination you want to sync to."]
      }), "\n", _jsx(_components.h3, {
        id: "syncing-messages",
        children: "Syncing messages"
      }), "\n", _jsxs(_components.p, {
        children: ["Hightouch supports sending messages based on rows that have been ", _jsx(_components.a, {
          href: "/getting-started/concepts#change-data-capture-cdc",
          children: "added, changed, or removed"
        }), " since the last sync run."]
      }), "\n", " ", "\n", _jsxs(_components.p, {
        children: [_jsxs(Tip, {
          children: ["This is only applicable when using the ", _jsx(_components.strong, {
            children: "Message"
          }), " sync type"]
        }), "\nEach row is sent as an individual message and can be ", _jsx(_components.a, {
          href: "#templating-messages",
          children: "templated with Liquid"
        }), ".\nYou can also send messages to ", _jsx(_components.a, {
          href: "#channel-selection",
          children: "different Slack channels"
        }), "."]
      }), "\n", _jsxs(Tip, {
        children: [_jsxs(_components.p, {
          children: ["Hightouch doesn't send any messages on the initial sync run to prevent a flood of messages to your channel. Messages start appearing ", _jsx(_components.strong, {
            children: "after"
          }), " the initial sync run. The same behavior applies to ", _jsx(_components.a, {
            href: "/syncs/overview#resync-full-query",
            children: "full resyncs"
          }), " as well."]
        }), _jsx("br", {}), _jsx(_components.p, {
          children: "If you want avoid this behavior, modify your model query to return only one \"test\" row. Hightouch processes this row during the first sync run and doesn't send it as a message to Slack. Afterward, update your model query to include all rows from your source. Hightouch syncs all subsequent rows to Slack during the second sync run."
        })]
      }), "\n", _jsx(_components.h4, {
        id: "channel-selection",
        children: "Channel selection"
      }), "\n", _jsxs(_components.p, {
        children: ["After adding the Hightouch bot to a Slack channel, you can select it from this dropdown menu or enter a channel ID manually.\nYou can also enable the ", _jsx(_components.strong, {
          children: "Use column"
        }), " toggle to select a model column instead of a Slack channel name.\nThe model column selected in the dropdown menu must contain the correct Slack channel ID for every row in your model.\nThis also allows you to dynamically set the target channel, by inserting different Slack channel IDs for different rows in your model."]
      }), "\n", _jsx(_components.p, {
        children: _jsx(_components.img, {
          src: "destinations/destination-slack-channel-selection.png",
          alt: "Slack channel selection"
        })
      }), "\n", _jsx(_components.h4, {
        id: "private-channels",
        children: "Private channels"
      }), "\n", _jsx(_components.p, {
        children: "Private channels are hidden from the dropdown. To send to a private channel you can manually enter the channel ID."
      }), "\n", _jsx(Info, {
        children: _jsxs(_components.p, {
          children: ["Check out the ", _jsx(_components.a, {
            href: "#slack-channel-not-appearing-in-sync-configuration",
            children: "Common\nerrors"
          }), " section if you\ndon't see your Slack channel in this menu."]
        })
      }), "\n", _jsx(_components.h4, {
        id: "added-changed-and-removed-messages",
        children: "Added, changed, and removed messages"
      }), "\n", _jsx(_components.p, {
        children: "Hightouch allows you to send different messages based on the row type:"
      }), "\n", _jsxs(_components.ul, {
        children: ["\n", _jsxs(_components.li, {
          children: ["when a row is ", _jsx(_components.strong, {
            children: "added"
          }), " to your query results, Hightouch will send the ", _jsx(_components.em, {
            children: "row added"
          }), " content."]
        }), "\n", _jsxs(_components.li, {
          children: ["when a row is ", _jsx(_components.strong, {
            children: "changed"
          }), " in your query results, Hightouch will send the ", _jsx(_components.em, {
            children: "row changed"
          }), " content."]
        }), "\n", _jsxs(_components.li, {
          children: ["when a row is ", _jsx(_components.strong, {
            children: "deleted"
          }), " from your query results, Hightouch will send the ", _jsx(_components.em, {
            children: "row deleted"
          }), " content."]
        }), "\n"]
      }), "\n", _jsxs(_components.p, {
        children: ["This content can be ", _jsx(_components.a, {
          href: "#liquid-templating",
          children: "templated"
        }), " and also supports the ", _jsx(_components.a, {
          href: "#slack-block-kit",
          children: "Slack Block Kit"
        }), "."]
      }), "\n", _jsx(_components.p, {
        children: _jsx(_components.img, {
          src: "destinations/destination-slack-message-content.png",
          alt: "Message sync mode"
        })
      }), "\n", _jsx(Info, {
        children: _jsxs(_components.p, {
          children: ["Check out the ", _jsx(_components.a, {
            href: "#parseerror-unexpected-token",
            children: "Common errors"
          }), " section if your\ncolumn name contains spaces."]
        })
      }), "\n", _jsx(_components.h3, {
        id: "syncing-batch-messages",
        children: "Syncing batch messages"
      }), "\n", _jsxs(_components.p, {
        children: ["The batch message sync mode is similar to the normal ", _jsx(_components.a, {
          href: "#syncing-messages",
          children: "message"
        }), " mode, except it sends all rows in the query result rather than only ", _jsx(_components.a, {
          href: "/getting-started/concepts#change-data-capture-cdc",
          children: "added, changed, or removed rows"
        }), ".\nThis sync mode is ideal if you want to write a template and have Hightouch push a message containing ", _jsx(_components.strong, {
          children: "all"
        }), " rows to Slack, formatted as a single message."]
      }), "\n", _jsxs(_components.p, {
        children: ["This mode also allows you to specify how many rows are sent per message, which can range from 1 to 50.\nWith 1 row per message, it behaves similar to the ", _jsx(_components.a, {
          href: "#syncing-messages",
          children: "message"
        }), " sync mode since it creates multiple messages in Slack.\nWhereas 50 rows per message is similar to the ", _jsx(_components.a, {
          href: "#syncing-tables",
          children: "table"
        }), " sync mode."]
      }), "\n", _jsx(_components.h4, {
        id: "channel-selection-1",
        children: "Channel selection"
      }), "\n", _jsxs(_components.p, {
        children: ["The batch message sync mode only supports sending your messages to a single channel, unlike the ", _jsx(_components.a, {
          href: "#channel-selection",
          children: "message"
        }), " mode."]
      }), "\n", _jsx(_components.p, {
        children: _jsx(_components.img, {
          src: "destinations/destination-slack-channel-selection-1.png",
          alt: "Slack channel selection"
        })
      }), "\n", _jsx(_components.h4, {
        id: "private-channels-1",
        children: "Private channels"
      }), "\n", _jsx(_components.p, {
        children: "Private channels are hidden from the dropdown. To send to a private channel you can manually enter the channel ID."
      }), "\n", _jsx(_components.h4, {
        id: "header-body-and-footer-content",
        children: "Header, body, and footer content"
      }), "\n", _jsx(_components.p, {
        children: "For each message, Hightouch allows setting the header, body, and footer content.\nThe header and footer are optional, whereas the message body is required.\nThe body is repeated for every row in your model."
      }), "\n", _jsxs(_components.p, {
        children: ["This content can be ", _jsx(_components.a, {
          href: "#liquid-templating",
          children: "templated"
        }), " and also supports the ", _jsx(_components.a, {
          href: "#slack-block-kit",
          children: "Slack Block Kit"
        }), "."]
      }), "\n", _jsx(_components.p, {
        children: _jsx(_components.img, {
          src: "destinations/destination-slack-batch-message-content.png",
          alt: "Batch message sync mode"
        })
      }), "\n", _jsx(Info, {
        children: _jsxs(_components.p, {
          children: ["Check out the ", _jsx(_components.a, {
            href: "#parseerror-unexpected-token",
            children: "Common errors"
          }), " section if your\ncolumn name contains spaces."]
        })
      }), "\n", _jsx(_components.h3, {
        id: "syncing-tables",
        children: "Syncing tables"
      }), "\n", _jsxs(_components.p, {
        children: ["The table sync mode is similar to the ", _jsx(_components.a, {
          href: "#syncing-batch-messages",
          children: "batch message"
        }), " mode.\nIt sends all of your query results as a table-formatted message to Slack.\nThis mode is only recommended for small datasets."]
      }), "\n", _jsx(_components.h3, {
        id: "syncing-csv-files",
        children: "Syncing CSV files"
      }), "\n", _jsxs(_components.p, {
        children: ["The CSV sync mode is similar to the ", _jsx(_components.a, {
          href: "#syncing-batch-messages",
          children: "batch message"
        }), " and ", _jsx(_components.a, {
          href: "#syncing-tables",
          children: "table"
        }), " modes.\nIt sends all of your query results as a CSV file attached to a Slack message."]
      }), "\n", _jsx(_components.h3, {
        id: "templating-messages",
        children: "Templating messages"
      }), "\n", _jsxs(_components.p, {
        children: [_jsx(_components.a, {
          href: "/syncs/mapping-data#liquid-reference",
          children: "Liquid templating"
        }), " is supported for the ", _jsx(_components.a, {
          href: "#syncing-messages",
          children: "message"
        }), " and ", _jsx(_components.a, {
          href: "#syncing-batch-messages",
          children: "batch message"
        }), " sync modes.\nThis allows you to include model columns as part of the message body to insert dynamic values in your Slack messages.\nHere is an example message making use of Liquid to include model columns in a message:"]
      }), "\n", _jsx(_components.pre, {
        children: _jsx(_components.code, {
          className: "hljs language-text",
          children: "User with name {{ row['first name'] }} and email {{ email }} has signed up\n"
        })
      }), "\n", _jsxs(_components.p, {
        children: ["Check out our ", _jsx(_components.a, {
          href: "/syncs/mapping-data#extended-liquid-use-cases",
          children: "Extended Liquid use cases"
        }), " section to learn how to format ", _jsx(_components.a, {
          href: "/syncs/mapping-data#date-function",
          children: "dates"
        }), ", ", _jsx(_components.a, {
          href: "/syncs/mapping-data#string-functions",
          children: "strings"
        }), " or ", _jsx(_components.a, {
          href: "/syncs/mapping-data#currency-amounts",
          children: "currency amounts"
        }), "."]
      }), "\n", _jsx(_components.h4, {
        id: "tagging-slack-users-",
        children: "Tagging Slack users (@...)"
      }), "\n", _jsxs(_components.p, {
        children: ["Hightouch supports tagging users by either their ", _jsx(_components.strong, {
          children: "Slack User ID"
        }), " or by email:"]
      }), "\n", _jsxs(_components.ul, {
        children: ["\n", _jsxs(_components.li, {
          children: [_jsx(_components.strong, {
            children: "Tagging by User ID:"
          }), " tag by user ID by writing ", _jsx(_components.code, {
            children: "<@{{ userId }}>"
          }), " where ", _jsx(_components.code, {
            children: "userId"
          }), " is the column that contains the user's Slack ID. If the ", _jsx(_components.code, {
            children: "userId"
          }), " is a static value, you can write something like ", _jsx(_components.code, {
            children: "<@UL53466SY>"
          }), "."]
        }), "\n", _jsxs(_components.li, {
          children: [_jsx(_components.strong, {
            children: "Tagging by Email:"
          }), " tag by email by writing ", _jsx(_components.code, {
            children: "<@{{ email | slack_user_lookup }}>"
          }), " where email is the column that contains the user's email used in Slack. If the email is a static value, you can write something like ", _jsx(_components.code, {
            children: "<@{{ \"example@gmail.com\" | slack_user_lookup }}>"
          }), "."]
        }), "\n"]
      }), "\n", _jsx(_components.h4, {
        id: "inserting-urls",
        children: "Inserting URLs"
      }), "\n", _jsx(_components.p, {
        children: "You can insert URLs by highlighting a section of your template and pasting the URL."
      }), "\n", _jsxs(_components.p, {
        children: ["Otherwise, you can build URLs directly by following this format: ", _jsx(_components.code, {
          children: "<URL link|URL text>"
        }), ".\nFor example, a URL that points to a Salesforce organization's page could look like this: ", _jsx(_components.code, {
          children: "<https://www.salesforce.com/organization/{{ org_id }}/view|Salesforce Organization>"
        })]
      }), "\n", _jsxs(_components.p, {
        children: ["We recommend using the second method when building dynamic URLs with ", _jsx(_components.a, {
          href: "#templating-messages",
          children: "liquid templating"
        }), "."]
      }), "\n", _jsx(_components.h4, {
        id: "unfurling-links-and-blocking-unfurl",
        children: "Unfurling links and blocking unfurl"
      }), "\n", _jsxs(_components.p, {
        children: ["By default, Slack automatically unfurls (displays a preview of) URL links in your messages.\nTo prevent automatic unfurling, surround the URL with backticks (", _jsx(_components.code, {
          children: "`"
        }), "), for example:"]
      }), "\n", _jsx(_components.p, {
        children: _jsx(_components.code, {
          children: "`https://www.hightouch.com/`"
        })
      }), "\n", _jsx(Info, {
        children: _jsxs(_components.p, {
          children: ["The ", _jsx(_components.a, {
            href: "https://en.wikipedia.org/wiki/Backtick",
            children: "backtick"
          }), " is usually located\nabove the tab key on the left-hand side of the keyboard."]
        })
      }), "\n", _jsx(Warning, {
        children: _jsxs(_components.p, {
          children: ["Blocking URL unfurling isn't possible when using the ", _jsx(_components.a, {
            href: "#slack-block-kit",
            children: "Slack Block\nKit"
          }), ". Please", " ", "\n", _jsx(PylonLink, {
            pylonText: "Hello, I'm setting up a sync to the Slack destination and I'm interested in blocking URL unfurling when using the Slack Block Kit. This isn't supported yet, so I would like to submit a Feature Request.",
            linkText: "reach out"
          }), " ", "\nif you would like to request this feature."]
        })
      }), "\n", _jsx(_components.h4, {
        id: "formatting-text-for-app-for-slack-surfaces",
        children: "Formatting text for app for Slack surfaces"
      }), "\n", _jsxs(_components.p, {
        children: ["Slack provides an ", _jsx(_components.a, {
          href: "https://api.slack.com/reference/surfaces/formatting",
          children: "extensive guide"
        }), " to formatting surfaces in the app for Slack with instructions on how to:"]
      }), "\n", _jsxs(_components.ul, {
        children: ["\n", _jsx(_components.li, {
          children: "format text"
        }), "\n", _jsx(_components.li, {
          children: "insert emojis"
        }), "\n", _jsx(_components.li, {
          children: "mention users and channels"
        }), "\n", _jsx(_components.li, {
          children: "format dates, quotes, and lists"
        }), "\n"]
      }), "\n", "\n", _jsx(_components.h3, {
        id: "slack-block-kit",
        children: "Slack Block Kit"
      }), "\n", "\n", _jsxs(_components.p, {
        children: ["To enable the Slack Block Kit, select ", _jsx(_components.strong, {
          children: "Slack Block Kit"
        }), " for the content type.\nMake sure to use ", _jsx(_components.a, {
          href: "https://app.slack.com/block-kit-builder",
          children: "Slack's Block Kit Builder"
        }), " to draft your message content."]
      }), "\n", _jsx(_components.p, {
        children: _jsx(_components.img, {
          src: "destinations/destination-slack-block-kit-1.png",
          alt: "Slack Block Kit selection"
        })
      }), "\n", _jsx(_components.p, {
        children: "Each message content must be an array of Slack blocks, here is an example of a valid configuration."
      }), "\n", _jsx(_components.p, {
        children: _jsx(_components.img, {
          src: "destinations/destination-slack-block-kit-2.png",
          alt: "Slack Block Kit template"
        })
      }), "\n", _jsxs(_components.p, {
        children: ["The ", _jsx(_components.strong, {
          children: "Test Block Kit"
        }), " button under the message content allows you to view your templates as a Slack message (", _jsx(_components.a, {
          href: "https://app.slack.com/block-kit-builder/T0215BZEKB2#%7B%22blocks%22:%5B%7B%22type%22:%22section%22,%22text%22:%7B%22type%22:%22mrkdwn%22,%22text%22:%22hello!%22%7D%7D,%7B%22type%22:%22section%22,%22text%22:%7B%22type%22:%22mrkdwn%22,%22text%22:%22email:%20%7B%7B%20email%20%7D%7D%22%7D%7D,%7B%22type%22:%22section%22,%22text%22:%7B%22type%22:%22mrkdwn%22,%22text%22:%22goodbye!%22%7D%7D%5D%7D",
          children: "view an example"
        }), ")."]
      }), "\n", _jsx(_components.h3, {
        id: "customizing-bot-appearance",
        children: "Customizing bot appearance"
      }), "\n", _jsx(_components.p, {
        children: "Hightouch also allows you to customize how the Hightouch bot is displayed when sending messages to your Slack channel.\nYou can find these fields in your sync configuration:"
      }), "\n", _jsxs(_components.table, {
        children: [_jsx(_components.thead, {
          children: _jsxs(_components.tr, {
            children: [_jsx(_components.th, {
              align: "left",
              children: "Name"
            }), _jsx(_components.th, {
              align: "left",
              children: "Description"
            })]
          })
        }), _jsxs(_components.tbody, {
          children: [_jsxs(_components.tr, {
            children: [_jsx(_components.td, {
              align: "left",
              children: "Display name"
            }), _jsx(_components.td, {
              align: "left",
              children: "Display name of the Hightouch bot"
            })]
          }), _jsxs(_components.tr, {
            children: [_jsx(_components.td, {
              align: "left",
              children: "Icon URL"
            }), _jsx(_components.td, {
              align: "left",
              children: "URL of a 48x48 image that you wish to use as the bot icon"
            })]
          }), _jsxs(_components.tr, {
            children: [_jsx(_components.td, {
              align: "left",
              children: "Emoji"
            }), _jsxs(_components.td, {
              align: "left",
              children: ["Slack emoji to use instead of an icon image (for example, ", _jsx(_components.code, {
                children: ":sweat_smile:"
              }), ")"]
            })]
          })]
        })]
      }), "\n", _jsx(_components.p, {
        children: "Keep in mind that users in the channel will be able to see the real bot name and image by clicking on it."
      }), "\n", _jsx(_components.p, {
        children: _jsx(_components.img, {
          src: "destinations/destination-slack-bot-logo.png",
          alt: "Hightouch Slack bot logo"
        })
      }), "\n", _jsx(_components.h2, {
        id: "tips-and-troubleshooting",
        children: "Tips and troubleshooting"
      }), "\n", _jsx(Info, {
        children: _jsxs(_components.p, {
          children: ["For Hightouch platform error codes related to Slack, see ", _jsx(_components.a, {
            href: "/developer-tools/error-codes#slack",
            children: "Error codes: Slack"
          }), "."]
        })
      }), "\n", _jsx(_components.h3, {
        id: "common-errors",
        children: "Common errors"
      }), "\n", _jsx(CommonErrorsPreface, {}), "\n", _jsx(_components.h4, {
        id: "slack-channel-not-appearing-in-sync-configuration",
        children: "Slack channel not appearing in sync configuration"
      }), "\n", _jsxs(_components.p, {
        children: ["If your Slack channel isn't appearing in the ", _jsx(_components.a, {
          href: "#channel-selection",
          children: "channel selection menu"
        }), ", make sure that you ", _jsx(_components.a, {
          href: "#adding-the-hightouch-bot-to-a-channel",
          children: "added the Hightouch bot"
        }), " to the channel.\nIf this still doesn't work, try ", _jsx(_components.a, {
          href: "#authenticating-with-oauth",
          children: "reauthorizing your Slack destination"
        }), " in Hightouch.\nAs a next troubleshooting step, remove the Hightouch app for Slack from your Slack workspace by visiting the ", _jsx(_components.a, {
          href: "https://hightouchexternal.slack.com/apps/A010ZEEB44R-hightouch?tab=settings&next_id=0",
          children: "Hightouch app page"
        }), ", opening the ", _jsx(_components.strong, {
          children: "Configuration"
        }), " tab, and clicking ", _jsx(_components.strong, {
          children: "Remove App"
        }), "."]
      }), "\n", _jsx(_components.p, {
        children: _jsx(_components.img, {
          src: "destinations/destination-slack-remove-bot.png",
          alt: "Remove Slack bot"
        })
      }), "\n", _jsxs(_components.p, {
        children: ["Then ", _jsx(_components.a, {
          href: "#authenticating-with-oauth",
          children: "set up a new Slack destination"
        }), " and ", _jsx(_components.a, {
          href: "#adding-the-hightouch-bot-to-a-channel",
          children: "add the Hightouch bot"
        }), " to your Slack channel once more."]
      }), "\n", _jsx(_components.h4, {
        id: "invalid_blocks",
        children: "Invalid_blocks"
      }), "\n", _jsxs(_components.p, {
        children: ["Using ", _jsx(_components.code, {
          children: "\"plain_text\""
        }), " instead of ", _jsx(_components.code, {
          children: "\"mrkdwn\""
        }), " in your Slack Block Kit syntax is the most common cause of this error.\nYou can find examples of the correct syntax to use in the ", _jsx(_components.a, {
          href: "#slack-block-kit",
          children: "Slack Block Kit section"
        }), " of this page."]
      }), "\n", _jsx(_components.h4, {
        id: "cannot-read-properties-of-undefined-reading-length",
        children: "Cannot read properties of undefined (reading 'length')"
      }), "\n", _jsxs(_components.p, {
        children: ["You may receive the ", _jsx(_components.code, {
          children: "Cannot read properties of undefined (reading 'length')"
        }), " error when syncing ", _jsx(_components.a, {
          href: "#syncing-batch-messages",
          children: "batch messages"
        }), ".\nIf you're using the ", _jsx(_components.a, {
          href: "#slack-block-kit",
          children: "Slack Block Kit"
        }), " as the content type, your sync might return this error instead:\n", _jsx(_components.code, {
          children: "Parsing failed with error SyntaxError: Unexpected end of JSON input"
        }), "."]
      }), "\n", _jsxs(_components.p, {
        children: ["In either case, make sure to insert ", _jsx(_components.strong, {
          children: "body"
        }), " content in the sync configuration.\nHeader and footer content is optional."]
      }), "\n", _jsx(_components.p, {
        children: _jsx(_components.img, {
          src: "destinations/destination-slack-body-content.png",
          alt: "Slack Sync configuration in Hightouch"
        })
      }), "\n", "\n", _jsx(_components.h4, {
        id: "parseerror-unexpected-token",
        children: "ParseError: unexpected token"
      }), "\n", "\n", _jsxs(_components.p, {
        children: ["The full error message may look like, ", _jsx(_components.code, {
          children: "unexpected token at \"name\", line:1, col:13"
        }), ". You may receive this error because a column header that is being referenced in your message contains a space. For example:"]
      }), "\n", _jsx(_components.pre, {
        children: _jsx(_components.code, {
          className: "hljs language-text",
          children: "First Name: {{ first name }}\n"
        })
      }), "\n", _jsx(_components.p, {
        children: "To resolve this error you can try the following options:"
      }), "\n", _jsxs(_components.ul, {
        children: ["\n", _jsxs(_components.li, {
          children: ["Rename your column so that the name does not contain spaces, for example, ", _jsx(_components.code, {
            children: "firstName"
          }), " or ", _jsx(_components.code, {
            children: "first_name"
          }), ".\nAn example will look like:"]
        }), "\n"]
      }), "\n", _jsx(_components.pre, {
        children: _jsx(_components.code, {
          className: "hljs language-text",
          children: "First Name: {{ first_name }}\n"
        })
      }), "\n", _jsxs(_components.ul, {
        children: ["\n", _jsxs(_components.li, {
          children: ["If you cannot change the column's name then you can use this language of ", _jsx(_components.a, {
            href: "/syncs/mapping-data#liquid-reference",
            children: "liquid templating"
          }), ". An example will look like:"]
        }), "\n"]
      }), "\n", _jsx(_components.pre, {
        children: _jsx(_components.code, {
          className: "hljs language-text",
          children: "First Name: {{ row['first name'] }}\n"
        })
      }), "\n", _jsx(_components.h3, {
        id: "live-debugger",
        children: "Live debugger"
      }), "\n", _jsx(LiveDebugger, {}), "\n", _jsx(_components.h3, {
        id: "sync-alerts",
        children: "Sync alerts"
      }), "\n", _jsx(SyncAlerts, {})]
    });
  }
}
export default MDXContent;
function _missingMdxReference(id, component) {
  throw new Error("Expected " + (component ? "component" : "object") + " `" + id + "` to be defined: you likely forgot to import, pass, or provide it.");
}
